<template>
  <div class="mobile-container">
    <div class="mobile-header">
      <div class="mobile-header-left">
        <div class="mobile-column">
          <h1 class="mobile-title">
            <b-icon-person-lines-fill class="title-icon"/>
            Cadastro de Fornecedor
          </h1>
          <span class="required-hint">* Campos obrigatórios</span>
        </div>
        </div>
      <button
        v-if="onClose"
        class="btn-close-modern"
        @click="onClose"
      >
        <i class="fas fa-times"></i>
        Fechar
      </button>
    </div>
    
    <div class="tab-content">
      <input hidden v-model="dadosSupplier.id">
      
      <div class="compact-section">
        <div class="section-header">
          <b-icon-person-fill class="section-icon"/>
          <span>Dados Principais</span>
        </div>
        <div class="form-grid">
          <div class="form-group full-width">
            <input
              class="form-input"
              v-model="dadosSupplier.nomeFantasia"
              placeholder=""
            />
            <label class="form-label">
              Nome Fantasia <span class="required">*</span>
            </label>
          </div>
          
          <div class="form-group full-width">
            <input
              class="form-input"
              v-model="dadosSupplier.razaoSocial"
              placeholder=""
            />
            <label class="form-label">
              Razão Social <span class="required">*</span>
            </label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosSupplier.cpfCnpj"
              v-mask="maskCpfCnpj"
              placeholder=""
            />
            <label class="form-label">
              CNPJ/CPF <span class="required">*</span>
            </label>
            <button
              class="action-btn"
              @click="fetchCnpj(dadosSupplier.cpfCnpj)"
            >
              <b-spinner v-if="spinGeneralCnpj" small/>
              <span v-else>🔍</span>
            </button>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosSupplier.ie"
              placeholder=""
            />
            <label class="form-label">Inscrição Estadual</label>
          </div>
        </div>
      </div>

      <div class="compact-section">
        <div class="section-header">
          <b-icon-geo-alt-fill class="section-icon"/>
          <span>Endereço</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosSupplier.cep"
              placeholder=""
            />
            <label class="form-label">CEP</label>
            <button
              class="action-btn"
              @click="fetchCep(dadosSupplier.cep)"
            >
              <b-spinner v-if="spinGeneral" small/>
              <span v-else>🔍</span>
            </button>
          </div>
          
          <div class="form-group two-thirds">
            <input
              class="form-input"
              v-model="dadosSupplier.endereco"
              placeholder=""
            />
            <label class="form-label">Endereço</label>
          </div>
          
          <div class="form-group one-third">
            <input
              class="form-input"
              v-model="dadosSupplier.numero"
              placeholder=""
            />
            <label class="form-label">Número</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosSupplier.bairro"
              placeholder=""
            />
            <label class="form-label">Bairro</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosSupplier.cidade"
              placeholder=""
            />
            <label class="form-label">Cidade</label>
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              class="form-select"
              value-field="value"
              text-field="text"
              :options="ufs"
              v-model="dadosSupplier.uf"
            />
            <label class="select-label">UF</label>
          </div>
        </div>
      </div>

      <div class="compact-section">
        <div class="section-header">
          <b-icon-telephone-fill class="section-icon"/>
          <span>Contato</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <input
              class="form-input"
              v-mask="maskTelefone"
              v-model="dadosSupplier.telefone"
              placeholder=""
            />
            <label class="form-label">Telefone</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosSupplier.celular"
              v-mask="maskCelular"
              placeholder=""
            />
            <label class="form-label">Celular</label>
          </div>
          
          <div class="form-group full-width">
            <input
              class="form-input"
              type="email"
              v-model="dadosSupplier.email"
              placeholder=""
            />
            <label class="form-label">Email</label>
          </div>
        </div>
      </div>

      <div class="compact-section">
        <div class="section-header">
          <b-icon-info-circle class="section-icon"/>
          <span>Outras Informações</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <input
              class="form-input"
              v-model="dadosSupplier.chavePix"
              placeholder=""
            />
            <label class="form-label">Chave Pix</label>
          </div>
          
          <div class="form-group full-width">
            <textarea
              class="form-textarea"
              v-model="dadosSupplier.observacoes"
              placeholder=""
            />
            <label class="form-label">Observações</label>
          </div>
          <div class="form-group select-group">
            <b-form-select
              v-model="dadosSupplier.status"
              class="form-select"
              :options="statusOptions"
              :disabled="!dadosSupplier.id"
            />
            <label class="select-label">Status</label>
          </div>
        </div>
      </div>

      <div class="action-buttons-fixed">
        <button class="btn-secondary" @click="clear">
          <b-icon-arrow-clockwise/>
          Novo
        </button>
        <button class="btn-primary" @click="saveAndUpdateSupplier">
          <b-icon-check2-circle/>
          {{ dadosSupplier.id ? "Atualizar" : "Salvar" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/axios";
import toastAlertErros from "../../utils/toastAlertErros";
import ServiceSupplier from "../../services/serviceSupplier";
import { mapMutations, mapState } from "vuex";
import { HandleErrors } from "../../utils/handleErrors";
import { handleCpfOrCnpj } from "../../utils/validateCpfCnpj";
import { ufs } from "../../common/index";

export default {
  props: {
    dataSupplier: {
      type: Object,
    },
    onClose: {
      type: Function,
      default: null,
    },
  },
  components: {},
  data() {
    return {
      dadosSupplier: {
        id: "",
        nomeFantasia: "",
        razaoSocial: "",
        cpfCnpj: "",
        ie: "",
        endereco: "",
        numero: "",
        bairro: "",
        cidade: "",
        uf: "",
        email: "",
        telefone: "",
        celular: "",
        chavePix: "",
        observacoes: "",
        status: "ativo",
      },
      statusOptions: [
        { value: "ativo", text: "Ativo" },
        { value: "inativo", text: "Inativo" },
      ],
      spinGeneral: false,
      spinGeneralCnpj: false,
      ufs: ufs,
    };
  },
  methods: {
    ...mapMutations([
      "SET_IS_SEARCH_REGISTERS",
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_SUPPLIER",
    ]),
    async saveSupllier() {
      try {
        const result = handleCpfOrCnpj(this.dadosSupplier.cpfCnpj, this.$toast);
        if (result && !result.isValid) {
          return result.alert();
        }

        const id = await ServiceSupplier.saveSupllier(this.dadosSupplier);
        this.dadosSupplier.id = id;

        this.$emit("getAllSupplier", this.getSupplier);
        this.getSupplier = !this.getSupplier;
        this.SET_IS_SEARCH_REGISTERS();
        this.clear();
        return this.$toast.open({
          message: "Fornecedor salvo com sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
      }
    },

    async updateSupplier() {
      try {
        const result = handleCpfOrCnpj(this.dadosSupplier.cpfCnpj, this.$toast);
        if (result && !result.isValid) {
          return result.alert();
        }

        await api.put(
          `/Providers/${this.dadosSupplier.id}`,
          this.dadosSupplier
        );

        this.$emit("getAllSupplier", this.getSupplier);
        this.getSupplier = !this.getSupplier;
        this.SET_IS_SEARCH_REGISTERS();
        this.clear();
        return this.$toast.open({
          message: "Fornecedor atualizado com sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
      }
    },

    saveAndUpdateSupplier() {
      this.dadosSupplier.id !== ""
        ? this.updateSupplier()
        : this.saveSupllier();
    },

    assingEditSupplier() {
      this.dadosSupplier.id = this.dataSearchSupplier.id;
      this.dadosSupplier.nomeFantasia = this.dataSearchSupplier.nomeFantasia;
      this.dadosSupplier.razaoSocial = this.dataSearchSupplier.razaoSocial;
      this.dadosSupplier.cpfCnpj = this.dataSearchSupplier.cpfCnpj;
      this.dadosSupplier.ie = this.dataSearchSupplier.ie;
      this.dadosSupplier.endereco = this.dataSearchSupplier.endereco;
      this.dadosSupplier.numero = this.dataSearchSupplier.numero;
      this.dadosSupplier.bairro = this.dataSearchSupplier.bairro;
      this.dadosSupplier.cidade = this.dataSearchSupplier.cidade;
      this.dadosSupplier.uf = this.dataSearchSupplier.uf;
      this.dadosSupplier.email = this.dataSearchSupplier.email;
      this.dadosSupplier.telefone = this.dataSearchSupplier.telefone;
      this.dadosSupplier.celular = this.dataSearchSupplier.celular;
      this.dadosSupplier.observacoes = this.dataSearchSupplier.observacoes;
      this.dadosSupplier.chavePix = this.dataSearchSupplier.chavePix;
      this.dadosSupplier.cep = this.dataSearchSupplier.cep;
      this.dadosSupplier.status = this.dataSearchSupplier.status || "ativo";
    },

    clear() {
      this.dadosSupplier.id = "";
      this.dadosSupplier.nomeFantasia = "";
      this.dadosSupplier.razaoSocial = "";
      this.dadosSupplier.cpfCnpj = "";
      this.dadosSupplier.ie = "";
      this.dadosSupplier.endereco = "";
      this.dadosSupplier.numero = "";
      this.dadosSupplier.bairro = "";
      this.dadosSupplier.cidade = "";
      this.dadosSupplier.uf = "";
      this.dadosSupplier.email = "";
      this.dadosSupplier.telefone = "";
      this.dadosSupplier.celular = "";
      this.dadosSupplier.observacoes = "";
      this.dadosSupplier.chavePix = "";
      this.dadosSupplier.status = "ativo";
    },
    async fetchCep(cep) {
      try {
        this.spinGeneral = true;
        const formatedCep = cep.replace(/\D/g, "");
        const data = await api.get(
          `https://brasilapi.com.br/api/cep/v1/${formatedCep}`
        );
        this.dadosSupplier.endereco = data.data.street;
        this.dadosSupplier.bairro = data.data.neighborhood;
        this.dadosSupplier.cidade = data.data.city;
        this.dadosSupplier.uf = data.data.state;
        this.dadosSupplier.cep = data.data.cep;
      } catch (error) {
        this.$toast.open({
          message:
            "Ocorreu um erro ao buscar as informações , verifique o CEP e tente novamente",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    async fetchCnpj(cnpj) {
      try {
        this.spinGeneralCnpj = true;
        const formatedCnpj = cnpj.replace(/\D/g, "");
        const data = await api.get(
          `https://brasilapi.com.br/api/cnpj/v1/${formatedCnpj}`
        );

        if (data.data.nome_fantasia) {
          this.dadosSupplier.nomeFantasia = data.data.nome_fantasia;
        } else {
          this.dadosSupplier.nomeFantasia = data.data.razao_social;
        }
        this.dadosSupplier.razaoSocial = data.data.razao_social;
        this.dadosSupplier.endereco = data.data.logradouro;
        this.dadosSupplier.numero = data.data.numero;
        this.dadosSupplier.bairro = data.data.bairro;
        this.dadosSupplier.cidade = data.data.municipio;
        this.dadosSupplier.uf = data.data.uf;
        this.dadosSupplier.telefone = data.data.ddd_telefone_1;
        this.dadosSupplier.cep = data.data.cep;
      } catch (error) {
        this.$toast.open({
          message:
            "Ocorreu um erro ao buscar as informações , verifique o CNPJ e tente novamente",
          type: "info",
        });
      } finally {
        this.spinGeneralCnpj = false;
      }
    },
    checkInputLength() {
      if (this.dadosSupplier.cpfCnpj.length === 18) this.$forceUpdate();
    },
  },
  watch: {
    dataSupplier() {
      Object.assign(this.dadosSupplier, this.dataSupplier);
      this.dadosSupplier.status = this.dataSupplier?.status || "ativo";
    },
  },
  mounted() {
    if (this.dataSearchSupplier.id) {
      this.assingEditSupplier();
    }
  },

  computed: {
    ...mapState({
      dataSearchSupplier: (state) => state.dataSearchSupplier,
    }),
    maskCpfCnpj() {
      if (this.dadosSupplier.cpfCnpj === null) {
        return "";
      }
      if (this.dadosSupplier.cpfCnpj.length <= 14) {
        return "###.###.###-##";
      }
      if (this.dadosSupplier.cpfCnpj.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    },

    maskCelular() {
      return "(##) #####-####";
    },
    maskTelefone() {
      return "(##) ####-####";
    },
  },
};
</script>
<style scoped>
.mobile-container {
  padding: 8px;
  max-width: 100vw;
  overflow-x: hidden;
  padding-bottom: 90px;
}

.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  margin-bottom: 12px;
  border-bottom: 2px solid #e8f5e8;
}

.mobile-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.mobile-column {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mobile-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #2d5016;
  margin: 0;
}

.title-icon {
  color: #4caf50;
}

.btn-close-modern {
  background: #f0f0f0;
  border: none;
  padding: 6px 14px;
  border-radius: 20px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.btn-close-modern:hover {
  background: #ff4d4d;
  color: white;
}

.required-hint {
  font-size: 10px;
  color: #f44336;
  font-weight: 500;
}

.tab-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.compact-section {
  background: linear-gradient(135deg, #fafafa, #f5f5f5);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e8e8e8;
}

.section-icon {
  color: #4caf50;
  font-size: 16px;
}

.section-header span {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.form-group {
  position: relative;
  min-height: 35px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group.two-thirds {
  grid-column: span 1;
  flex: 2;
}

.form-group.one-third {
  grid-column: span 1;
  flex: 1;
}

.form-input, .form-select, .form-textarea {
  width: 100%;
  height: 35px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  background: white;
  transition: all 0.2s ease;
  outline: none;
}

.form-input:focus, .form-select:focus, .form-textarea:focus {
  border-color: #4caf50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.1);
  transform: translateY(-1px);
}

.form-input.error, .form-select.error {
  border-color: #f44336;
  box-shadow: 0 0 0 2px rgba(244, 67, 54, 0.1);
}

.form-textarea {
  height: 60px;
  resize: vertical;
  min-height: 35px;
}

.form-label, .select-label {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #666;
  background: white;
  padding: 0 4px;
  pointer-events: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  z-index: 1;
}

.form-input:focus + .form-label,
.form-input:not(:placeholder-shown) + .form-label,
.form-select:focus + .select-label,
.form-select:not([value=""]) + .select-label {
  top: 0;
  transform: translateY(-50%) scale(0.85);
  color: #4caf50;
  font-weight: 600;
}

.required {
  color: #f44336;
  font-weight: 700;
}

.action-btn {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
}

.action-btn:hover {
  background: linear-gradient(135deg, #43a047, #5cb85c);
  transform: translateY(-50%) scale(1.05);
}

.action-buttons-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 12px;
  display: flex;
  gap: 12px;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
  z-index: 200;
}

.btn-primary, .btn-secondary {
  flex: 1;
  height: 44px;
  padding: 6px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #43a047, #5cb85c);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, #f5f5f5, #e0e0e0);
  color: #333;
  border: 1px solid #ddd;
}

.btn-secondary:hover {
  background: linear-gradient(135deg, #eeeeee, #d5d5d5);
  transform: translateY(-1px);
}

.select-group .form-select {
  padding-right: 30px;
}

@media (max-width: 480px) {
  .mobile-container {
    padding: 4px;
    padding-bottom: 90px;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  
  .form-group.two-thirds,
  .form-group.one-third {
    grid-column: 1;
  }
  
  .mobile-header {
    align-items: flex-start;
    gap: 4px;
  }
  
  .action-buttons-fixed {
    flex-direction: column;
  }
}

@media (min-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
  
  .mobile-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 16px;
    padding-bottom: 110px;
  }

  .action-buttons-fixed {
    max-width: 800px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.text-center { text-align: center; }
.text-right { text-align: right; }
.mb-0 { margin-bottom: 0; }
.mt-0 { margin-top: 0; }

.form-input:disabled,
.form-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

*:focus {
  outline: none;
}

.form-input:focus,
.form-select:focus,
.btn-primary:focus,
.btn-secondary:focus {
  outline: 2px solid #4caf50;
  outline-offset: 2px;
}
</style>
